


















import Vue from "vue";
import configRaw from "../config.json";
import { LanguageSelectorConfig } from "./interfaces";
import LanguagePage from "./components/organisms/LanguagePage/LanguagePage.vue";
import Modal from "./components/molecules/Modal/Modal.vue";
import { getLanguageFromPath } from "./helpers/getLanguageFromPath";
import ContinuePrompts, { ContinuePrompt } from "./store/ContinuePrompts";
import constructLaunchURL from "./helpers/constructLaunchURL";
import Languages, { isoLanguageCodes } from "./store/Languages";
import {
  LanguageChoice,
  retrieveLanguageChoice
} from "./helpers/languageChoice";
import resetSCORMTrackingData from "./helpers/resetSCORMTrackingData";

const config: LanguageSelectorConfig = configRaw as LanguageSelectorConfig;

// Only load global scss for current theme
require("~styles");

export default Vue.extend({
  name: "App",
  components: {
    LanguagePage,
    Modal
  },
  data: () => {
    return {
      config: config,
      logoUrl: require("~logo"),
      persistedOption: retrieveLanguageChoice(),
      isContinuePromptActive: false
    };
  },
  computed: {
    continuePromptLanguageCode: function(): isoLanguageCodes | null {
      if (!this.persistedOption) return null;
      const languagePath = this.persistedOption.path;
      const languageCode = getLanguageFromPath(languagePath) || "mul";
      return languageCode;
    },
    continuePromptDir: function(): "ltr" | "rtl" {
      if (!this.continuePromptLanguageCode) return "ltr";
      return Languages[this.continuePromptLanguageCode].dir;
    },
    continuePromptContent: function(): ContinuePrompt {
      const languageCode = this.continuePromptLanguageCode;
      const language =
        ContinuePrompts[languageCode as isoLanguageCodes] ||
        ContinuePrompts["mul"];
      return language as ContinuePrompt;
    }
  },
  mounted: function() {
    if (this.persistedOption) this.showContinuePrompt();
  },
  methods: {
    showContinuePrompt: function() {
      this.isContinuePromptActive = true;
    },
    onContinuePromptCancel: function() {
      this.isContinuePromptActive = false;

      // Focus keyboard on first language item
      document.querySelectorAll("a")[0].focus();

      // If the learner wishes to change language, reset the progress
      if (config.trackingMethod.indexOf("SCORM") !== -1) {
        resetSCORMTrackingData(config.trackingMethod);
      }
    },
    onContinuePromptConfirm: function() {
      window.location.href = constructLaunchURL(
        (this.persistedOption as LanguageChoice).path
      );
    }
  }
});
